import { Directive, HostListener } from '@angular/core';

/**
 * Directive that trims leading/trailing whitespace from pasted text.
 * Works seamlessly with Angular reactive forms by dispatching
 * a native `input` event after modifying the value, which the
 * DefaultValueAccessor picks up automatically.
 */
@Directive({
  selector: 'textarea[trimOnPaste], input[trimOnPaste]',
  standalone: true,
})
export class TrimOnPasteDirective {
  @HostListener('paste', ['$event'])
  public onPaste(event: Event): void {
    if (!(event instanceof ClipboardEvent)) {
      return;
    }
    const text = event.clipboardData?.getData('text');

    if (!text || text === text.trim()) {
      return;
    }

    event.preventDefault();

    const el = event.target as HTMLInputElement | HTMLTextAreaElement;
    const start = el.selectionStart ?? 0;
    const end = el.selectionEnd ?? 0;
    const trimmed = text.trim();

    el.value = el.value.substring(0, start) + trimmed + el.value.substring(end);
    el.selectionStart = el.selectionEnd = start + trimmed.length;

    // Notify Angular's DefaultValueAccessor of the change
    el.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
